/* eslint-disable */
import Vue from 'vue';
import Vuex from 'vuex';
import VueFirestore from 'vue-firestore';
import utils from "@/api/utils"
import {
  db
} from '@/api/firebaseInit';
import {
  auth
} from '@/api/firebaseInit';
import firebase, {
  firestore
} from 'firebase';
import {
  sign
} from 'jsonwebtoken';
import {
  formatDate
} from 'tough-cookie';

Vue.use(Vuex);
Vue.use(VueFirestore);
export const store = new Vuex.Store({
  state: {
    verify_ecc_val:false,
    events:[],
    Members: [],
    users: [],
    users_ecc: [],
    users_emp: [],
    users_ecc_emp: [],
    users_ecc_emp_crea: [],
    users_emp_crea: [],
    serviteurs: [],
    massaga: [],
    messages: [],
    convos: [],
    todays: [],
    employees: [],
    currentEmployee: '',
    valideUsers: [],
    referrals: [],
    africell: [],
    airtel: [],
    vodaphone: [],
    orangeTigo: [],
    currentMemberId: '',
    currentMember: {},
    memberPhoto: '/static/avatar/avatar.png',
    others: [],
    signinUser: {},
    loginLoading: false,
    dashboardLoading: false,
    prayers: [],
    prayers_ecc: [],
    announcements: [],
    announcements_ecc: [],
    friends:[],
    groups:[],
    projects:[],
    jobs:[],
    medias:[],
    merchants:[],
    coupons:[],
    kyc:[],
    kyc_ecc:[]
  },
  getters: {
    // ...
    getMemberById: (state) => (uuid) => {
      return state.Members.find(item => item.id === uuid);
    },
    getConvById: (state) => (uuid) => {
      return state.convos.find(item => item.uuid === uuid);
    },
    getEmployeeById: (state) => (uuid) => {
      return state.employees.find(item => item.id === uuid);
    },
    getUserById: (state) => (uuid) => {
      return state.users.find(item => item.uuid === uuid);
    },
    getUserECCById: (state) => (uuid) => {
      return state.users_ecc.find(item => item.uuid === uuid);
    },
    getCurrentMember(state) {
      return state.currentMember;
    },
    getCurrentMemberId(state) {
      return state.currentMemberId;
    },
    deleteUserById: (state) => (uuid) => {
      return state.Members.find(item => item.id === uuid);
    },
    deleteEmployeeById: (state) => (uuid) => {
      (state, payload) => {
        var index = state.employees.findIndex(todo => todo.id === payload);
        state.employees.splice(index, 1);
      }
      return state.employees.find(item => item.id === uuid);
    },
    members(state) {
      return state.Members;
    },
    kyc(state) {
      return state.kyc;
    },
    kyc_ecc(state) {
      return state.kyc_ecc;
    },
    events(state) {
      return state.events;
    },

    serviteurs(state) {
      //SS
      state.serviteurs = state.Members.filter(item => item.role === 'serviteurs');
      return state.serviteurs;
    },
    massaga(state) {
      //MC
      state.massaga = state.Members.filter(item => item.role === 'masanga');
      return state.massaga;
    },
    users_ecc_emp(state) {
      //MC
      state.users_ecc_emp = state.users_ecc.filter(item => item.type === 'E');
      return state.users_ecc_emp;
    },
    users_emp(state) {
      //MC
      state.users_emp = state.users.filter(item => item.type === 'E');
      return state.users_emp;
    },
    valideUsers(state) {
      state.valideUsers = state.Members.filter(item => (item.lastName));
      return state.valideUsers;
    },
    referrals(state) {
      return state.referrals;
    },
    emptyUsers(state) {
      state.emptyUsers = state.Members.filter(item => (!item.phone));
      return state.emptyUsers;
    },
    todays(state) {
      let today = (new Date());
      today = new Date(today.setHours(0, 0, 0, 0));
      state.todays = state.Members.filter(item => item.createdDate >= today);
      return state.todays;
    },
    users(state) {
      return state.users;
    },
    users_ecc(state) {
      return state.users_ecc;
    },
    users_ecc_emp_crea(state) {
      return state.users_ecc_emp_crea;
    },
    users_emp_crea(state) {
      return state.users_emp_crea;
    },
    employees(state) {
      return state.employees;
    },

    friends(state) {
      return state.friends;
    },
    groups(state) {
      return state.groups;
    },
    medias(state) {
      return state.medias;
    },
    merchants(state) {
      return state.merchants;
    },
    coupons(state) {
      return state.coupons;
    },
    projects(state) {
      return state.projects;
    },

    jobs(state) {
      return state.jobs;
    },
    
    convos(state) {
      return state.convos;
    },
    currentEmployee(state) {
      return state.currentEmployee;
    },
    africell(state) {
      state.africell = state.Members.filter(item => (item.cellType) === 'africell');
      return state.africell;
    },
    airtel(state) {
      state.airtel = state.Members.filter(item => (item.cellType) === 'airtel');
      return state.airtel;
    },
    orangeTigo(state) {
      state.orangeTigo = state.Members.filter(item => (item.cellType) === 'orangeTigo');
      return state.orangeTigo;
    },
    vodaphone(state) {
      state.vodaphone = state.Members.filter(item => (item.cellType) === 'vodaphone');
      return state.vodaphone;
    },
    others(state) {
      state.others = state.Members.filter(item => (item.cellType) === 'Non connue');
      return state.others;
    },
    memberPhoto(state) {
      return state.memberPhoto;
    },
    signinUser(state) {
      return state.signinUser;
    },
    loginLoading(state) {
      return state.loginLoading;
    },
    verify_ecc_val(state) {
      return state.verify_ecc_val;
    },
    dashboardingLoading(state) {
      return state.dashboardingLoading;
    },
    prayers(state) {
      return state.prayers;
    },
    prayers_ecc(state) {
      return state.prayers_ecc;
    },
    announcements(state) {
      return state.announcements;
    },
    announcements_ecc(state) {
      return state.announcements_ecc;
    },
    messages(state) {
      return state.messages;
    }
  },
  mutations: {
    kyc(state, payload) {
      state.kyc = payload;
    },
    kyc_ecc(state, payload) {
      state.kyc_ecc = payload;
    },
    merchants(state,payload) {
      state.merchants = payload;
    },
    coupons(state, payload) {
      state.coupons = payload;
    },
    events(state, payload) {
      state.events = payload;
    },
    users(state, payload) {
      state.users = payload;
    },
    users_ecc_emp_crea(state, payload) {
      state.users_ecc_emp_crea = payload;
    },
    users_emp_crea(state, payload) {
      state.users_emp_crea = payload;
    },
    users_ecc(state, payload) {
      state.users_ecc = payload;
    },
    friends(state, payload) {
      state.friends = payload;
    },
    members(state, payload) {
      state.Members = payload;
    },
    valideUsers(state, payload) {
      state.valideUsers = payload;
    },
    addMember(state, payload) {
      state.Members.push(payload);
    },
    setSigninUser(state, payload) {
      state.signinUser = payload
    },
    employees(state, payload) {
      state.employees = payload;
    },
    convos(state, payload) {
      state.convos = payload;
    },
    groups(state, payload) {
      state.groups = payload;
    },
    projects(state, payload) {
      state.projects = payload;
    },
    jobs(state, payload) {
      state.jobs = payload;
    },
    memberPhoto(state, payload) {
      state.memberPhoto = payload;
    },
    referrals(state, payload) {
      state.referrals = payload;
    },
    currentMemberId(state, payload) {
      state.currentMemberId = payload;
    },
    currentMember(state, payload) {
      state.currentMember = payload;
    },
    deleteMember(state, payload) {
      const index = state.Members.findIndex(t => t.id === payload)
      state.Members.splice(index, 1);
    },
    deleteEmployee(state, payload) {
      const index = state.employees.findIndex(t => t.id === payload)
      state.employees.splice(index, 1);
      // state.currentMember = payload;
    },
    currentEmployee(state, payload) {
      state.currentEmployee = payload;
    },
    loginLoading(state, payload) {
      state.loginLoading = payload;
    },
    verify_ecc_val(state, payload) {
      state.verify_ecc_val = payload;
    },
    dashboardLoading(state, payload) {
      state.dashboardLoading = payload;
    },
    prayers(state, payload) {
      state.prayers = payload;
    },
    prayers_ecc(state, payload) {
      state.prayers_ecc = payload;
    },
    announcements(state, payload) {
      state.announcements = payload;
    },
    announcements_ecc(state, payload) {
      state.announcements_ecc = payload;
    },
    messages(state, payload) {
      state.messages = payload;
    },
    medias(state, payload) {
      state.medias = payload;
    },
  },

  actions: {
    Logout_main :function(context) {
      firebase
     .auth()
     .signOut()
     .then(() => {
       //localStorage.clear();
       //this.$router.push('/login');
     });
    },

     sleep : function (delay) {
      var start = new Date().getTime();
      while (new Date().getTime() < start + delay);
  },

     verify_ecc : function (context,usr) {  
      return new Promise((resolve, reject) => {
        const ecc_a = []
         console.log("in verify")
       db.collection("Users_ecc").where("id", "==", usr.id)
           .get().then(function(querySnapshot) {
          
        querySnapshot.forEach(function(doc) {
          const data = {ecc:true}
          ecc_a.push(data);
        });   
    })

    setTimeout(() => {
      console.log("ecc length",ecc_a.length)
      if(ecc_a.length > 0) {
      console.log("ecc_a t",JSON.stringify(ecc_a))
      context.commit('verify_ecc_val',ecc_a[0].ecc)
      } else {
        context.commit('verify_ecc_val',false)
      }
    
      resolve()
    }, 1000)
      })
      },
    signUserIn: function (context, payload) {
    
      //here
      firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
        .then(
          () => {
            let user = firebase.auth().currentUser
            db.collection("Users_ecc").where("id", "==", user.uid)
           .get().then(function(querySnapshot) {
            if (querySnapshot.empty) {
              console.log("bima")
            db.collection("Users").doc(user.uid)
              .get()
              .then((doc) => {
                if (doc.exists) {
                  const newUser = {
                  
                    id:doc.data().id,
                    address: doc.data().address,
                    firstName: doc.data().first_name,
                    lastName: doc.data().last_name,
                    city: doc.data().city,
                    phone: ""+doc.data().phone_number,
                    email: doc.data().email,
                    type:doc.data().type,
                    imageUrl: doc.data().image_url,
                    type:doc.data().type,
                    role:doc.data().role,
                    congregation:"bima",
                    fullName: doc.data().first_name + ' ' + doc.data().last_name
                  }
                  context.commit('setSigninUser', newUser)
                  store.dispatch('fetchUsers')
                  store.dispatch('fetchUsers_ecc')
                  //store.dispatch('fetchMembers')
                /* 
                  store.dispatch('fetchConvos')
                  store.dispatch('fetchMessages')
                  store.dispatch('fetchFriends')*/
                  localStorage.email = payload.email
                  localStorage.password = payload.password
                } else {
                  var arr = user.displayName.split(/\s+/);
                  const newUser = {
                    id: user.uid,
                    imageUrl: '/static/avatar/avatar.png',
                    accessLevel: "Clerk",
                    fullName: user.displayName,
                    firstName: arr[0],
                    lastName: arr[arr.length - 1]
                  }
                  context.commit('setSigninUser', newUser)
                  //store.dispatch('fetchUsers')
                  //store.dispatch('fetchUsers_ecc')
                  //store.dispatch('fetchMembers')
                /*  
                  store.dispatch('fetchConvos')
                  store.dispatch('fetchMessages')
                  store.dispatch('fetchFriends')*/
                  localStorage.email = payload.email
                  localStorage.password = payload.password
                }

              })
          } else {
              // do something with the data
       
            querySnapshot.forEach(function(doc) {
           
              console.log("ecc")
            
                if (doc.exists) {
                  const newUser = {
                  
                    id:doc.data().id,
                    address: doc.data().address,
                    firstName: doc.data().first_name,
                    lastName: doc.data().last_name,
                    city: doc.data().city,
                    phone: ""+doc.data().phone_number,
                    email: doc.data().email,
                    type:doc.data().type,
                    imageUrl: doc.data().image_url,
                    type:doc.data().type,
                    role:doc.data().role,
                    congregation:"ecc",
                    fullName: doc.data().first_name + ' ' + doc.data().last_name
                  }
                  context.commit('setSigninUser', newUser)
                  //store.dispatch('fetchUsers')
                  //store.dispatch('fetchUsers_ecc')
                  //store.dispatch('fetchMembers')
                /* 
                  store.dispatch('fetchConvos')
                  store.dispatch('fetchMessages')
                  store.dispatch('fetchFriends')*/
                  localStorage.email = payload.email
                  localStorage.password = payload.password
                } else  {
                  var arr = user.displayName.split(/\s+/);
                  const newUser = {
                    id: user.uid,
                    imageUrl: '/static/avatar/avatar.png',
                    accessLevel: "Clerk",
                    fullName: user.displayName,
                    firstName: arr[0],
                    lastName: arr[arr.length - 1]
                  }
                  context.commit('setSigninUser', newUser)
                  //store.dispatch('fetchUsers')
                  //store.dispatch('fetchUsers_ecc')
                 // store.dispatch('fetchMembers')
                /*  
                  store.dispatch('fetchConvos')
                  store.dispatch('fetchMessages')
                  store.dispatch('fetchFriends')*/
                  localStorage.email = payload.email
                  localStorage.password = payload.password
                }
            
          });  
        } 
        })
    
          })
        .catch(
          error => {
            context.commit('loginLoading', false)
            alert(error.message);
          })
        
    },

    fetchChangedSigninUserInfo: function (context) {
    
      auth.onAuthStateChanged(function (user) {
        
        if (user) {
         
          db.collection("Users_ecc").where("id", "==", user.uid)
          .get().then(function(querySnapshot) {
            if (querySnapshot.empty) {
              console.log("bima")
              db
              .collection("Users").doc(user.uid)
              .get()
              .then((doc) => {
                if (doc.exists) {
                  const newUser = {
                    id:user.uid,
                    address: doc.data().address,
                    firstName: doc.data().first_name,
                    lastName: doc.data().last_name,
                    city: doc.data().city,
                    phone: ""+doc.data().phone_number,
                    email: doc.data().email,
                    imageUrl: doc.data().image_url,
                    type:doc.data().type,
                    congregation:"bima",
                    fullName: doc.data().first_name + ' ' + doc.data().last_name
                  }
                  context.commit('setSigninUser', newUser)
                 // store.dispatch('fetchUsers')
                 // store.dispatch('fetchUsers_ecc')
                 // store.dispatch('fetchMembers')
                 /* 
                  store.dispatch('fetchConvos')
                  store.dispatch('fetchMessages')
                  store.dispatch('fetchFriends')*/
                } else {
                  var arr = user.displayName.split(/\s+/);
                  const newUser = {
                    id: user.uid,
                    imageUrl: '/static/avatar/avatar.png',
                    accessLevel: "Clerk",
                    fullName: user.displayName,
                    firstName: arr[0],
                    lastName: arr[arr.length - 1]
                  }
                  context.commit('setSigninUser', newUser)
                 // store.dispatch('fetchUsers')
                 // store.dispatch('fetchUsers_ecc')
                  //store.dispatch('fetchMembers')
                 /*  store.dispatch('fetchConvos')
                  store.dispatch('fetchMessages')
                  store.dispatch('fetchFriends')*/
                }
                
              })
              .catch(
                error => {
                  context.commit('loginLoading', false)
                  alert(error.message);
                })

            } else {
       querySnapshot.forEach(function(doc) {

            
            console.log("ecc")
        
              if (doc.exists) {
                const newUser = {
                  id:user.uid,
                  address: doc.data().address,
                  firstName: doc.data().first_name,
                  lastName: doc.data().last_name,
                  city: doc.data().city,
                  phone: ""+doc.data().phone_number,
                  email: doc.data().email,
                  imageUrl: doc.data().image_url,
                  type:doc.data().type,
                  congregation:"ecc",
                  fullName: doc.data().first_name + ' ' + doc.data().last_name
                }
                context.commit('setSigninUser', newUser)
                store.dispatch('fetchUsers')
                store.dispatch('fetchUsers_ecc')
                //store.dispatch('fetchMembers')
               /* //
                store.dispatch('fetchConvos')
                store.dispatch('fetchMessages')
                store.dispatch('fetchFriends')*/
              } else {
                var arr = user.displayName.split(/\s+/);
                const newUser = {
                  id: user.uid,
                  imageUrl: '/static/avatar/avatar.png',
                  accessLevel: "Clerk",
                  fullName: user.displayName,
                  firstName: arr[0],
                  lastName: arr[arr.length - 1]
                }
                context.commit('setSigninUser', newUser)
                store.dispatch('fetchUsers')
                store.dispatch('fetchUsers_ecc')
                //store.dispatch('fetchMembers')
               /*  store.dispatch('fetchConvos')
                store.dispatch('fetchMessages')
                store.dispatch('fetchFriends')*/
              }
        
            
          }); 
        }  
        })
        
        } else {
          // No user is signed in.
          this.$router.push({name: 'login'})
         // this.$router.push('/login');
        }
      });
    },
    newMember: function (context) {
      var memberRef = db.collection("Census").doc();
      var refKey = memberRef.id;
      var newAccessCode = refKey.substring(0, 5);
      memberRef
        .set({
          accessCode: newAccessCode,
          imageUrl: '/static/avatar/avatar.png',
          createdBy: this.createdBy,
          createdById: this.currentUser,
          createdDate: new Date()
        })
      context.commit('currentMemberId', refKey)
    },
    dispatchMember: async ({
      commit
    }, payload) => {
      const form = await fetch_Member(payload)
      if (form) {
        commit('currentMember', form);
      }
      return form
    },
    fetchCurrentMember: function (context, payload) {
      db.collection('Census').doc(payload)
        .get()
        .then((doc) => {
          const form = {
            id: doc.id,
            imageUrl: doc.data().imageUrl,
            firstName: doc.data().firstName,
            lastName: doc.data().lastName,
            accessCode: doc.data().accessCode,
            role: doc.data().role,
            phone: doc.data().phone,
            email: doc.data().email,
            dateOfBirth: doc.data().dateOfBirth,
            address: doc.data().address,
            gender: doc.data().gender,
            consent: doc.data().consent,
            city: doc.data().city,
            postalCode: doc.data().postalCode,
            isWithChildren: doc.data().isWithChildren,
            hasSmartPhone: doc.data().hasSmartPhone,
            noPhoneReason: doc.data().noPhoneReason,
            isBuyPhoneReady: doc.data().isBuyPhoneReady,
            maritalStatus: doc.data().maritalStatus,
            noVolunteerReason: doc.data().noVolunteerReason,
            isVolunteer: doc.data().isVolunteer,
            hasChildren: doc.data().hasChildren,
            volunteerFrequency: doc.data().volunteerFrequency,
            niveauScolaire: doc.data().niveauScolaire,
            churchName: doc.data().churchName,
            churchAttendance: doc.data().churchAttendance,
            memberSince: doc.data().memberSince,
            sermonTimeSpent: doc.data().sermonTimeSpent,
            isreferralReady: doc.data().isreferralReady,
            noReferralReason: doc.data().noReferralReason,
            isVolunteerReady: doc.data().isVolunteerReady,
            noVolunteerReason: doc.data().noVolunteerReason,
            volunteerTime: doc.data().volunteerTime,
            noDonationReason: doc.data().noDonationReason,
            donation: doc.data().donation,
            isDimeContribution: doc.data().isDimeContribution,
            isDonationReady: doc.data().isDonationReady,
            // dimeAmount: doc.data().dimeAmount,
            dime: doc.data().dime,
            dimeType: doc.data().dimeType,
            isOffrandeContribution: doc.data().isOffrandeContribution,
            // offrandeAmount: doc.data().offrandeAmount,
            offrandeType: doc.data().offrandeType,
            offrande: doc.data().offrande,
            isGraceContribution: doc.data().isGraceContribution,
            // graceDonationAmount: doc.data().graceDonationAmount,
            graceContributionType: doc.data().graceContributionType,
            isWorking: doc.data().isWorking,
            createdDate: doc.data().createdDate,
            isWorkReady: doc.data().isWorkReady,
            notAvailableReason: doc.data().notAvailableReason,
            isEducationReady: doc.data().isEducationReady,
            isHouseOwner: doc.data().isHouseOwner,
            houseOwnerSince: doc.data().houseOwnerSince,
            isRenting: doc.data().isRenting,
            jobSkills: doc.data().jobSkills,
            jobSearch: doc.data().jobSearch,
            jobType: doc.data().jobType,
            availableTime: doc.data().availableTime,
            jobDisponibility: doc.data().jobDisponibility,
            timeOnCurrentJob: doc.data().timeOnCurrentJob,
            jobPosition: doc.data().jobPosition,
            numberOfJobs: doc.data().numberOfJobs,
            jobRepartition: doc.data().jobRepartition,
            jobWeeklyHours: doc.data().jobWeeklyHours,
            jobTravelDistance: doc.data().jobTravelDistance,
            jobTravelMode: doc.data().jobTravelMode,
            jobTravelCost: doc.data().jobTravelCost,
            jobTravelTime: doc.data().jobTravelTime,
            jobMonthlyPay: doc.data().jobMonthlyPay
          }

          if (doc.data().imageUrl === "./src/assets/avatar.png") {
            form.imageUrl = memberPhoto;
          }
          if (
            doc.data().isBuyPhoneReady === null ||
            doc.data().isBuyPhoneReady === undefined
          ) {
            form.isBuyPhoneReady = false;
          }
          if (
            doc.data().isVolunteerReady === null ||
            doc.data().isVolunteerReady === undefined
          ) {
            form.isVolunteerReady = "Non";
          }
          if (
            doc.data().volunteerTime === null ||
            doc.data().volunteerTime === undefined
          ) {
            form.volunteerTime.amount = 0;
            form.volunteerTime.frequency = 'Par jour';
          }
          if (
            doc.data().houseOwnerSince === null ||
            doc.data().houseOwnerSince === undefined
          ) {
            form.houseOwnerSince = {
              nombre: 0,
              frequency: 'Par jour'
            }
          }
          if (
            doc.data().education === null ||
            doc.data().education === undefined
          ) {
            form.education = {
              nombre: 0,
              frequency: 'Par jour'
            }
          }
          if (
            doc.data().numberOfKids === null ||
            doc.data().noPhoneReason === undefined
          ) {
            form.numberOfKids = 0;
          }
          if (
            doc.data().noReferralReason === null ||
            doc.data().noReferralReason === undefined
          ) {
            form.noReferralReason = 'Pas de raison';
          }
          if (
            doc.data().noDonationReason === null ||
            doc.data().noDonationReason === undefined
          ) {
            form.noDonationReason = 'Pas de raison';
          }

          context.commit('currentMember', form)
        })

    },
    fetchMembers: function (context) {
      const Members = [];
      db
        .collection('Census')
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach(doc => {
        
            const data = {
              id: doc.id,
              city:doc.data().city,
              address:doc.data().address,
              postalCode:doc.data().postalCode,
              qr_url:doc.data().qr_url,
              imageUrl: doc.data().imageUrl,
              firstName: doc.data().firstName,
              lastName: doc.data().lastName,
              accessCode: doc.data().accessCode,
              role: doc.data().role,
              phone: doc.data().phone,
              email: doc.data().email,
              createdDate: doc.data().createdDate ,
              fullName: doc.data().firstName + ' ' + doc.data().lastName,
              card_id:doc.data().card_id,
             gender:doc.data().gender,
             maritalStatus:doc.data().maritalStatus,
             hasChildren:doc.data().hasChildren,
             dime:doc.data().dime,
             donation:doc.data().donation,
             education:doc.data().education,
             offrande:doc.data().offrande,
             churchName:doc.data().churchName,
             createdBy:doc.data().createdBy,
             dateOfBirth:doc.data().dateOfBirth,
             houseOwnerSince:doc.data().houseOwnerSince,
             jobDisponibility:doc.data().jobDisponibility,
             jobSearch:doc.data().jobSearch,
             timeOnCurrentJob : doc.data().timeOnCurrentJob,
             volunteerTime:doc.data().volunteerTime,
             niveauScolaire:doc.data().niveauScolaire,
             hasSmartPhone:doc.data().hasSmartPhone,
             memberSince:doc.data().memberSince,
           
              avatar: {
                src: '/static/avatar/avatar.png',
                size: 72
              },
            };
            if (data.imageUrl === '/assets/avatar.png') {
              data.imageUrl = '/static/avatar/avatar.png';
            }
            if (!data.consent) {
              data.consent = true
            }
            if (data.phone) {
              filterProviders(data);
              filterProviders2(data);
            }

            if(doc.data().qr_url != undefined) {
              var qr =  doc.data().qr_url
            data.qr_name=qr.substring(
              qr.lastIndexOf("%2F") + 3, 
              qr.lastIndexOf("?")
               )+".png"
            }

            if(doc.data().imageUrl == '/assets/avatar.png') {

              data.image_name = "avatar.png"
            }
            else if(doc.data().imageUrl != undefined) {
              var image =  doc.data().imageUrl
            data.image_name=image.substring(
              image.lastIndexOf("%2F") + 3, 
              image.lastIndexOf("?")
               )+".png"
            } 
              if(data.dateOfBirth) {
               
                data.dateOfBirth= new Date(data.dateOfBirth.seconds*1000)
              }

              if(data.createdDate) {

                data.createdDate= new Date(data.createdDate.seconds*1000)
              }

              if(data.role) {
                switch (data.role) {
                  case 'SS':
                      data.role= "serviteurs";
                    break;
                  case "MC":
                      data.role= "masanga";
                    break;
                    case "MS":
                      data.role= "masanga";
                    break;
                  case "YY":
                      data.role= "youth";
                    break;
                  case "CC":
                      data.role= "choristes";
                    break;
                  case "MM":
                      data.role= "members";
                    break;
                    case "FF":
                      data.role= "faithful";
                    break;
                   default:
                      data.role= data.role;
                }
                
              }

             // if(data.role =="Serviteur de Dieu") {
            Members.push(data);
          //}
          });
        })
      context.commit('loginLoading', false);
      context.commit('members', Members);
    },


     formatDate: function (date) {
      var d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();
  
      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;
  
      return [year, month, day].join('-');
  },
    fetchFriends: function (context) {
      return new Promise((resolve, reject) => {
        const friends = [];
        var currentUser = ''
        if (firebase.auth().currentUser) {
          currentUser = firebase.auth().currentUser.uid;
        }

      db.collection('friends').doc(currentUser).collection('friends')
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach(doc => {
           
              const data = {
                uuid: doc.id,
                entityKey: doc.id,
                first_name: doc.data().first_name,
                last_name: doc.data().last_name,
                online: doc.data().online,
                thumbnail_url: doc.data().thumbnail_url,
                user_id: doc.data().user_id,
                timestamp:doc.data().timestamp,
                fullName: doc.data().first_name + ' ' + doc.data().last_name,
                avatar: {
                  src: '/static/avatar/avatar.png',
                  size: 72
                },
              };
              if (data.thumbnail_url === 'default') {
                data.thumbnail_url = '/static/avatar/avatar.png';
              }
              data.avatar = data.thumbnail_url
              
              friends.push(data);
            
            });
          
          })
        context.commit('loginLoading', false);
        setTimeout(() => {
        
          context.commit('friends', friends);
       
          resolve()
        }, 1000)
      })
   
    },


    fetchEvents: function (context) {
    
      return new Promise((resolve, reject) => {

        var letters = '0123456789ABCDEF';
        var color = '#';
        for (var i = 0; i < 6; i++) {
          color += letters[Math.floor(Math.random() * 16)];
        }
        const events = [];
        var currentUser = ''
        if (firebase.auth().currentUser) {
          currentUser = firebase.auth().currentUser.uid;
        }
        db.collection('Events')
          .where('created_by_id','==',currentUser)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach(doc => {
               var end = new Date(doc.data().end_date.seconds*1000)
               var start = new Date(doc.data().start_date.seconds*1000)
                
              const data = {
                id:doc.id,
                category:doc.data().category,
                bgColor:doc.data().bgColor,
                dragBgColor:doc.data().dragBgColor,
                created_by:doc.data().created_date,
                created_by_id:doc.data().created_id, 
                body:doc.data().description,
                end:end,
                start:start,
                title:doc.data().title,
                location:doc.data().location
              }
                  
              events.push(data);
        
            });
          })
        context.commit('loginLoading', false);
        setTimeout(() => {
       //  console.log('events',JSON.stringify(events))
          context.commit('events', events);

          resolve()
        }, 1000)
      })
   
    },
    fetchMerchants: function (context) {
     // console.log('Merchants')
      return new Promise((resolve, reject) => {
        const merchants = [];
        var currentUser = ''
        if (firebase.auth().currentUser) {
          currentUser = firebase.auth().currentUser.uid;
        }
        db.collection('Merchants')
          //.where('owner_id','==',currentUser)
          .get()
          .then((querySnapshot) => {
           
            querySnapshot.forEach(doc => {
               
              var created_date = new Date(doc.data().created_date.seconds*1000)
              var date_opened = new Date(doc.data().date_opened.seconds*1000)
              const data = {
                merchant_id:doc.id,
                address: doc.data().address,
                business_description:doc.data().business_description,
                business_name:doc.data().business_name,
                coupon_ids:doc.data().coupon_ids,
                created_by:doc.data().created_by,  
                created_date:created_date, 
                
                imageUrl:doc.data().imageUrl, 
                MerchantPoint:doc.data().MerchantPoint,
                operating_hours:doc.data().operating_hours,
                owner_id:doc.data().owner_id,
                date_opened : date_opened,
                congregation:doc.data().congregation,
                phone:doc.data().phone
              }
                  
              merchants.push(data);
        
            });
          })
        context.commit('loginLoading', false);
        setTimeout(() => {
          context.commit('merchants', merchants);
          resolve()
        }, 1000)
      })
   
    },

    fetchCoupons_ecc: function (context) {
      // console.log('available_coupons')
       return new Promise((resolve, reject) => {
         const coupons = [];
         if (firebase.auth().currentUser) {
           currentUser = firebase.auth().currentUser.uid;
         }
         db.collection('available_coupons')
         .where('congregation','==','all')
         .get()
         .then((querySnapshot) => {
           querySnapshot.forEach(doc => {
            
             const data = {
               id:doc.id,
               barcode_url: doc.data().barcode_url,
               created_by_id:doc.data().created_by_id,
               created_date:doc.data().created_date,
               description:doc.data().description, 
               discount:doc.data().discount,
               expiration_date:doc.data().expiration_date, 
               merchant_id:doc.data().merchant_id,
               image_url:doc.data().image_url,
               store_name:doc.data().store_name,
               phone:doc.data().phone,
               address:doc.data().address,
               disclaimer:doc.data().disclaimer,
               congregation:doc.data().congregation,
             }
             if(data.created_date) {
              data.created_date = new Date(data.created_date.seconds*1000) 
            }
            if(data.expiration_date) {
              data.expiration_date = new Date(data.expiration_date.seconds*1000)  
            }     
             coupons.push(data);
       
           });
         })

         db.collection('available_coupons')
          .where('congregation','==','ecc')
           .get()
           .then((querySnapshot) => {
             querySnapshot.forEach(doc => {
               const data = {
                 id:doc.id,
                 barcode_url: doc.data().barcode_url,
                 created_by_id:doc.data().created_by_id,
                 created_date:doc.data().created_date,
                 description:doc.data().description, 
                 discount:doc.data().discount,
                 expiration_date:doc.data().expiration_date, 
                 merchant_id:doc.data().merchant_id,
                 image_url:doc.data().image_url,
                 store_name:doc.data().store_name,
                 phone:doc.data().phone,
                 address:doc.data().address,
                 disclaimer:doc.data().disclaimer,
                 congregation:doc.data().congregation,
               }
               if(data.created_date) {
                data.created_date = new Date(data.created_date.seconds*1000) 
              }
              if(data.expiration_date) {
                data.expiration_date = new Date(data.expiration_date.seconds*1000)  
              } 
               coupons.push(data);
         
             });
           })
        
         context.commit('loginLoading', false);
         setTimeout(() => {
           context.commit('coupons', coupons);
           resolve()
         }, 1000)
       })
    
     },

      fetchCoupons: function (context) {
      console.log('available_coupons')
      return new Promise((resolve, reject) => {
        const coupons = [];
        db.collection('available_coupons')
        .where('congregation','==',"bima")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach(doc => {
            
            const data = {
              id:doc.id,
              barcode_url: doc.data().barcode_url,
              created_by_id:doc.data().created_by_id,
              created_date:doc.data().created_date,
              description:doc.data().description, 
              discount:doc.data().discount,
              expiration_date:doc.data().expiration_date, 
              merchant_id:doc.data().merchant_id,
              image_url:doc.data().image_url,
              store_name:doc.data().store_name,
              phone:doc.data().phone,
              address:doc.data().address,
              disclaimer:doc.data().disclaimer,
              congregation:doc.data().congregation,
            }
            if(data.created_date) {
            data.created_date = new Date(data.created_date.seconds*1000) 
          }
          if(data.expiration_date) {
            data.expiration_date = new Date(data.expiration_date.seconds*1000)  
          }
            coupons.push(data);
      
          });
        })
        
        db.collection('available_coupons')
          .where('congregation','==',"all")
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach(doc => {
            
              const data = {
                id:doc.id,
                barcode_url: doc.data().barcode_url,
                created_by_id:doc.data().created_by_id,
                created_date:doc.data().created_date,
                description:doc.data().description, 
                discount:doc.data().discount,
                expiration_date:doc.data().expiration_date, 
                merchant_id:doc.data().merchant_id,
                image_url:doc.data().image_url,
                store_name:doc.data().store_name,
                phone:doc.data().phone,
                address:doc.data().address,
                disclaimer:doc.data().disclaimer,
                congregation:doc.data().congregation,
              }
              if(data.created_date) {
                data.created_date = new Date(data.created_date.seconds*1000) 
              }
              if(data.expiration_date) {
                data.expiration_date = new Date(data.expiration_date.seconds*1000)  
              }    
              coupons.push(data);
        
            });
          })    
        context.commit('loginLoading', false);
        setTimeout(() => {
          context.commit('coupons', coupons);
          resolve()
        }, 1000)
      })
   
    },
    fetchMedias: function (context) {
     // console.log('medias')
      return new Promise((resolve, reject) => {
        const medias = [];
        var currentUser = ''
        if (firebase.auth().currentUser) {
          currentUser = firebase.auth().currentUser.uid;
        }
        db.collection('medias')
          .where('created_by_id','==',currentUser)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach(doc => {
               
              const data = {
                id:doc.id,
                category: doc.data().category,
                created_date:doc.data().created_date,
                created_by:doc.data().created_by,
                created_by_id:doc.data().created_by_id,  
                data_type:doc.data().data_type, 
                description:doc.data().description, 
                tags:doc.data().tags,
                title:doc.data().title, 
                url:doc.data().url
              }
                  
              medias.push(data);
        
            });
          })
        context.commit('loginLoading', false);
        setTimeout(() => {
          context.commit('medias', medias);
          resolve()
        }, 1000)
      })
   
    },

    fetchJobs: function (context) {
      console.log('jobs')
      return new Promise((resolve, reject) => {
        const jobs = [];
        var currentUser = ''
        if (firebase.auth().currentUser) {
          currentUser = firebase.auth().currentUser.uid;
        }
        db.collection('Jobs')
          .where('created_by_id','==',currentUser)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach(doc => {
               
              const data = {
                id:doc.id,
                address: doc.data().address,
                available_position:doc.data().available_position,
                created_by_id:doc.data().created_by_id, 
                created_date:doc.data().created_date, 
                description:doc.data().description, 
                hourly_wages:doc.data().hourly_wages,
                job_end_date:doc.data().job_end_date, 
                project_id:doc.data().project_id,
               // project_name:doc.data().project_name, 
                skills_required:doc.data().skills_required,
                start_date:doc.data().start_date, 
                title:doc.data().title, 
                type:doc.data().type,
                weekly_hours:doc.data().weekly_hours 
              }
                  
              jobs.push(data);
        
            });
          })
        context.commit('loginLoading', false);
        setTimeout(() => {

        
          context.commit('jobs', jobs);
          resolve()
        }, 1000)
      })
   
    },

//**********kyc ECC*********************
fetchkyc_ecc: function (context) {
  return new Promise((resolve, reject) => {
    const kyc_ecc = [];
    db
      .collection('Kyc_ecc')
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach(doc => {
         
          const data = {
            id: doc.id,
            address_id : doc.data().address_id,
            card_id  :doc.data().card_id,
            completed  :doc.data().completed,
            date_of_birth :doc.data().date_of_birth,
            employee_id :doc.data().employee_id,
            employee_name  :doc.data().employee_name,
            first_id  :doc.data().first_id,
            first_name  :doc.data().first_name,
            last_name  :doc.data().last_name,
            payment_made  :doc.data().payment_made,
            post_name :doc.data().post_name,
            second_id :doc.data().second_id,
            standard_photo_url  :doc.data().standard_photo_url,
            timestamp :doc.data().timestamp,
            user_id  : doc.data().user_id
          };
          kyc_ecc.push(data);
         
        });
      })
    context.commit('loginLoading', false);
    setTimeout(() => {
      context.commit('kyc_ecc', kyc_ecc);
      resolve()
    }, 1000)
  })

},
//********************************** */
    fetchkyc: function (context) {
      return new Promise((resolve, reject) => {
        const kyc = [];
        db
          .collection('Kyc')
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach(doc => {
             
              const data = {
                id: doc.id,
                address_id : doc.data().address_id,
                card_id  :doc.data().card_id,
                completed  :doc.data().completed,
                date_of_birth :doc.data().date_of_birth,
                employee_id :doc.data().employee_id,
                employee_name  :doc.data().employee_name,
                first_id  :doc.data().first_id,
                first_name  :doc.data().first_name,
                last_name  :doc.data().last_name,
                payment_made  :doc.data().payment_made,
                post_name :doc.data().post_name,
                second_id :doc.data().second_id,
                standard_photo_url  :doc.data().standard_photo_url,
                timestamp :doc.data().timestamp,
                user_id  : doc.data().user_id
              };
              kyc.push(data);
             
            });
          })
        context.commit('loginLoading', false);
        setTimeout(() => {
          context.commit('kyc', kyc);
          resolve()
        }, 1000)
      })
   
    },
/****************USERS_ECC*************** */

fetchCRE_ecc_emp: function (context,id) {
  console.log("id from store :::  ",id)
  return new Promise((resolve, reject) => {
    const users_ecc_emp_crea = [];
    var currentUser = ''
    if (firebase.auth().currentUser) {
      currentUser = firebase.auth().currentUser.uid;
    }

    db
      .collection('Users_ecc')
      .where("created_by_id", "==", id)
      .orderBy('registration_date', 'desc')
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach(doc => {
         // if(doc.id != currentUser) {  
          const data  = {
            uuid: doc.id,
            access_code:doc.data().access_code ,
            address: doc.data().address,
            card_id :doc.data().card_id ,
            church_name :doc.data().church_name.toUpperCase() ,
            city: doc.data().city,
            date_of_birth: doc.data().date_of_birth,
            entityKey :doc.data().entityKey ,
            friend : doc.data().friend,
            gender : doc.data().gender,
            has_resume : doc.data().has_resume,
            lower_access_code :doc.data().lower_access_code ,
            lower_last_name :doc.data().lower_last_name ,
            marital_status : doc.data().marital_status,
            qr_url : doc.data().qr_url,
            region :doc.data().region ,
            original_date : doc.data().registration_date,
            registration_date : doc.data().registration_date,
            member_since :doc.data().member_since,
            type : doc.data().type,
            image_url: doc.data().image_url,
            standard_photo:doc.data().standard_photo,
            first_name: utils.jsUcfirst(doc.data().first_name),
            last_name: utils.jsUcfirst(doc.data().last_name),
            census_id: doc.data().census_id,
            status: doc.data().status,
            phone: doc.data().phone_number,
            online: doc.data().online,
            email: doc.data().email,
            status: doc.data().status,
            thumbnail_url: doc.data().thumbnail_url,
            fullName: utils.jsUcfirst(doc.data().first_name) + ' ' + utils.jsUcfirst(doc.data().last_name),
            name: doc.data().first_name + ' ' + doc.data().last_name,
            role:doc.data().role,
            payment_made :doc.data().payment_made+ "",
            bar_code:'OMNIC3 SARL ECC 0000',
            avatar: {
              src: '/static/avatar/avatar.png',
              size: 72
            },
          };
          if(data.payment_made == "true") {data.amount="5"} else {data.amount="0"}
          
          if (data.image_url.length ==0 ) {
            data.image_url = '/static/avatar/avatar.png';
          }

           if (data.image_url === "default" ) {
            data.image_url = '/static/avatar/avatar.png';
          }

          if (data.standard_photo.length ==0 ) {
            data.standard_photo = '/static/avatar/avatar.png';
          }

          data.avatar = data.image_url

            ///////*************** */

            if(doc.data().qr_url != undefined) {
              var qr =  doc.data().qr_url
            data.qr_name=qr.substring(
              qr.lastIndexOf("%2F") + 3, 
              qr.lastIndexOf("?")
               )+".png"
            }

            if(doc.data().standard_photo == '/assets/avatar.png') {

              data.image_name = "avatar.png"
            }
            else if(doc.data().standard_photo != undefined) {
              var image =  doc.data().standard_photo
              data.image_name=image.substring(
              image.lastIndexOf("%2F") + 3, 
              image.lastIndexOf("?")
               )+".jpg"
            } 

              if(data.date_of_birth) {
               
               data.date_of_birth=  new Date(data.date_of_birth.seconds*1000)
               let formatted_date = data.date_of_birth.getFullYear() + "-" + ("0" + (data.date_of_birth.getMonth() + 1)).slice(-2) + "-" +("0" + data.date_of_birth.getDate()).slice(-2)
               data.date_of_birth = formatted_date
              }
              data.original_date = new Date(data.original_date.seconds*1000)
              if(data.registration_date) {
              
                data.registration_date= new Date(data.registration_date.seconds*1000)
               
                let formatted_date = data.registration_date.getFullYear() + "-" + ("0" + (data.registration_date.getMonth() + 1)).slice(-2) + "-" +("0" + data.registration_date.getDate()).slice(-2)
                let formatted_time = data.registration_date.getHours() + ":" + data.registration_date.getMinutes() + ":" + data.registration_date.getSeconds() 
               
                data.registration_hour = formatted_time
                data.registration_date = formatted_date
              }

              if(data.member_since) {
                  
                data.member_since= new Date(data.member_since.seconds*1000)
               
                let formatted_date = data.member_since.getFullYear() + "-" + ("0" + (data.member_since.getMonth() + 1)).slice(-2) + "-" +("0" + data.member_since.getDate()).slice(-2)
                let formatted_time = data.member_since.getHours() + ":" + data.member_since.getMinutes() + ":" + data.member_since.getSeconds() 
               
                data.member_since_hour = formatted_time
                data.member_since = formatted_date
              }
              
        
              if(data.role) {
                switch (data.role) {
                  case 'PA':
                      data.role= "Pasteur";
                      break;
                  case 'DI':
                      data.role= "Diacre";
                    break;
                  case "EV":
                      data.role= "Évangeliste";
                    break;
                    case "IT":
                      data.role= "Intercesseur";
                    break;
                  case "CH":
                      data.role= "Chantre";
                    break;
                  case "PR":
                      data.role= "Protocole";
                    break;
                  case "FE":
                      data.role= "Femme";
                    break;
                    case "HO":
                      data.role= "Homme";
                    break;
                    case "JE":
                      data.role= "Jeune";
                    break;
                    case "AU":
                      data.role= "Aumônier";
                    break;
                    case "MI":
                      data.role= "Missionaire";
                    break;
                   default:
                      data.role= data.role;
          
                }}
                
              if(data.gender) {
                switch (data.gender) {
                  case 'femme':
                    data.gender= "F";
                    break;
                  case "male":
                    data.gender= "M";
                    break;
                    case "homme":
                      data.gender= "M";
                    break;
                   default:
                      data.gender= data.gender;
                }
                
              }
              users_ecc_emp_crea.push(data);
        
     // }

        });
      })
   // context.commit('loginLoading', false);
    setTimeout(() => {
     // context.commit('loginLoading', false)
      context.commit('users_ecc_emp_crea', users_ecc_emp_crea);
      resolve()
    }, 1000)
  })

},


fetchUsers_ecc: function (context) {
  return new Promise((resolve, reject) => {
    const users_ecc = [];
    var currentUser = ''
    if (firebase.auth().currentUser) {
      currentUser = firebase.auth().currentUser.uid;
    }

    db
      .collection('Users_ecc')
      .orderBy('registration_date', 'desc')
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach(doc => {
         // if(doc.id != currentUser) {  
          const data  = {
            uuid: doc.id,
            access_code:doc.data().access_code ,
            address: doc.data().address,
            card_id :doc.data().card_id ,
            church_name :doc.data().church_name.toUpperCase() ,
            city: doc.data().city,
            date_of_birth: doc.data().date_of_birth,
            entityKey :doc.data().entityKey ,
            friend : doc.data().friend,
            gender : doc.data().gender,
            has_resume : doc.data().has_resume,
            lower_access_code :doc.data().lower_access_code ,
            lower_last_name :doc.data().lower_last_name ,
            marital_status : doc.data().marital_status,
            qr_url : doc.data().qr_url,
            region :doc.data().region ,
            original_date : doc.data().registration_date,
            registration_date : doc.data().registration_date,
            member_since :doc.data().member_since,
            type : doc.data().type,
            image_url: doc.data().image_url,
            standard_photo:doc.data().standard_photo,
            first_name: utils.jsUcfirst(doc.data().first_name),
            last_name: utils.jsUcfirst(doc.data().last_name),
            census_id: doc.data().census_id,
            status: doc.data().status,
            phone: doc.data().phone_number,
            online: doc.data().online,
            email: doc.data().email,
            status: doc.data().status,
            thumbnail_url: doc.data().thumbnail_url,
            fullName: utils.jsUcfirst(doc.data().first_name) + ' ' + utils.jsUcfirst(doc.data().last_name),
            name: doc.data().first_name + ' ' + doc.data().last_name,
            role:doc.data().role,
            payment_made :doc.data().payment_made+ "",
            bar_code:'OMNIC3 SARL ECC 0000',
            avatar: {
              src: '/static/avatar/avatar.png',
              size: 72
            },
          };
          if(data.payment_made == "true") {data.amount="5"} else {data.amount="0"}
          
          if (data.image_url.length ==0 ) {
            data.image_url = '/static/avatar/avatar.png';
          }

           if (data.image_url === "default" ) {
            data.image_url = '/static/avatar/avatar.png';
          }

          if (data.standard_photo.length ==0 ) {
            data.standard_photo = '/static/avatar/avatar.png';
          }

          data.avatar = data.image_url

            ///////*************** */

            if(doc.data().qr_url != undefined) {
              var qr =  doc.data().qr_url
            data.qr_name=qr.substring(
              qr.lastIndexOf("%2F") + 3, 
              qr.lastIndexOf("?")
               )+".png"
            }

            if(doc.data().standard_photo == '/assets/avatar.png') {

              data.image_name = "avatar.png"
            }
            else if(doc.data().standard_photo != undefined) {
              var image =  doc.data().standard_photo
              data.image_name=image.substring(
              image.lastIndexOf("%2F") + 3, 
              image.lastIndexOf("?")
               )+".jpg"
            } 

              if(data.date_of_birth) {
               
               data.date_of_birth=  new Date(data.date_of_birth.seconds*1000)
               let formatted_date = data.date_of_birth.getFullYear() + "-" + ("0" + (data.date_of_birth.getMonth() + 1)).slice(-2) + "-" +("0" + data.date_of_birth.getDate()).slice(-2)
               data.date_of_birth = formatted_date
              }
              data.original_date = new Date(data.original_date.seconds*1000)
              if(data.registration_date) {
              
                data.registration_date= new Date(data.registration_date.seconds*1000)
               
                let formatted_date = data.registration_date.getFullYear() + "-" + ("0" + (data.registration_date.getMonth() + 1)).slice(-2) + "-" +("0" + data.registration_date.getDate()).slice(-2)
                let formatted_time = data.registration_date.getHours() + ":" + data.registration_date.getMinutes() + ":" + data.registration_date.getSeconds() 
               
                data.registration_hour = formatted_time
                data.registration_date = formatted_date
              }

              if(data.member_since) {
                  
                data.member_since= new Date(data.member_since.seconds*1000)
               
                let formatted_date = data.member_since.getFullYear() + "-" + ("0" + (data.member_since.getMonth() + 1)).slice(-2) + "-" +("0" + data.member_since.getDate()).slice(-2)
                let formatted_time = data.member_since.getHours() + ":" + data.member_since.getMinutes() + ":" + data.member_since.getSeconds() 
               
                data.member_since_hour = formatted_time
                data.member_since = formatted_date
              }
              
        
              if(data.role) {
                switch (data.role) {
                  case 'PA':
                      data.role= "Pasteur";
                      break;
                  case 'DI':
                      data.role= "Diacre";
                    break;
                  case "EV":
                      data.role= "Évangeliste";
                    break;
                    case "IT":
                      data.role= "Intercesseur";
                    break;
                  case "CH":
                      data.role= "Chantre";
                    break;
                  case "PR":
                      data.role= "Protocole";
                    break;
                  case "FE":
                      data.role= "Femme";
                    break;
                    case "HO":
                      data.role= "Homme";
                    break;
                    case "JE":
                      data.role= "Jeune";
                    break;
                    case "AU":
                      data.role= "Aumônier";
                    break;
                    case "MI":
                      data.role= "Missionaire";
                    break;
                   default:
                      data.role= data.role;
          
                }}
                
              if(data.gender) {
                switch (data.gender) {
                  case 'femme':
                    data.gender= "F";
                    break;
                  case "male":
                    data.gender= "M";
                    break;
                    case "homme":
                      data.gender= "M";
                    break;
                   default:
                      data.gender= data.gender;
                }
                
              }
          users_ecc.push(data);
        
     // }

        });
      })
   // context.commit('loginLoading', false);
    setTimeout(() => {
     // context.commit('loginLoading', false)
      context.commit('users_ecc', users_ecc);
      resolve()
    }, 1000)
  })

},


/**************************************** */
    fetchUsers: function (context) {
      return new Promise((resolve, reject) => {
        const users = [];
        var code = 187
        var i=0
        var currentUser = ''
        if (firebase.auth().currentUser) {
          currentUser = firebase.auth().currentUser.uid;
        }

        db
          .collection('Users')
          .orderBy('registration_date', 'desc')
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach(doc => {
              code=i+code
             // if(doc.id != currentUser) {  
              const data = {
                uuid: doc.id,
                access_code:doc.data().access_code ,
                address: doc.data().address,
                card_id :doc.data().card_id ,
                church_name :doc.data().church_name.toUpperCase() ,
                city: doc.data().city,
                date_of_birth: doc.data().date_of_birth,
                entityKey :doc.data().entityKey ,
                friend : doc.data().friend,
                gender : doc.data().gender,
                has_resume : doc.data().has_resume,
                lower_access_code :doc.data().lower_access_code ,
                lower_last_name :doc.data().lower_last_name ,
                marital_status : doc.data().marital_status,
                qr_url : doc.data().qr_url,
                region :doc.data().region ,
                original_date : doc.data().registration_date,
                registration_date : doc.data().registration_date,
                member_since:doc.data().member_since,
                type : doc.data().type,
                image_url: doc.data().image_url,
                standard_photo:doc.data().standard_photo,
                first_name: utils.jsUcfirst(doc.data().first_name),
                last_name: utils.jsUcfirst(doc.data().last_name),
                census_id: doc.data().census_id,
                status: doc.data().status,
                phone: doc.data().phone_number,
                online: doc.data().online,
                email: doc.data().email,
                status: doc.data().status,
                thumbnail_url: doc.data().thumbnail_url,
                fullName: doc.data().first_name + ' ' + doc.data().last_name,
                name: doc.data().first_name + ' ' + doc.data().last_name,
                role:doc.data().role,
                payment_made :doc.data().payment_made+ "",
                bar_code:'OMNIC3 SARL 0000',
                avatar: {
                  src: '/static/avatar/avatar.png',
                  size: 72
                },
              };
              if(data.payment_made == "true") {data.amount="5"} else {data.amount="0"}
              
              if (data.image_url.length ==0 ) {
                data.image_url = '/static/avatar/avatar.png';
              }
    
               if (data.image_url === "default" ) {
                data.image_url = '/static/avatar/avatar.png';
              }
             
          if (data.standard_photo.length == 0 ) {
           
            data.standard_photo = '/static/avatar/avatar.png';
          }
              data.avatar = data.image_url

                ///////*************** */

                if(doc.data().qr_url != undefined) {
                  var qr =  doc.data().qr_url
                data.qr_name=qr.substring(
                  qr.lastIndexOf("%2F") + 3, 
                  qr.lastIndexOf("?")
                   )+".png"
                }
    
                if(doc.data().standard_photo == '/assets/avatar.png') {
    
                  data.image_name = "avatar.png"
                }
                else if(doc.data().standard_photo != undefined) {
                  var image =  doc.data().standard_photo
                  data.image_name=image.substring(
                  image.lastIndexOf("%2F") + 3, 
                  image.lastIndexOf("?")
                   )+".jpg"
                } 

                if(data.date_of_birth) {
               
                  data.date_of_birth=  new Date(data.date_of_birth.seconds*1000)
                  let formatted_date = data.date_of_birth.getFullYear() + "-" + ("0" + (data.date_of_birth.getMonth() + 1)).slice(-2) + "-" +("0" + data.date_of_birth.getDate()).slice(-2)
                  data.date_of_birth = formatted_date
                 }
                  data.original_date = new Date(data.original_date.seconds*1000)
                  if(data.registration_date) {
                  
                    data.registration_date= new Date(data.registration_date.seconds*1000)
                   
                    let formatted_date = data.registration_date.getFullYear() + "-" + ("0" + (data.registration_date.getMonth() + 1)).slice(-2) + "-" +("0" + data.registration_date.getDate()).slice(-2)
                    let formatted_time = data.registration_date.getHours() + ":" + data.registration_date.getMinutes() + ":" + data.registration_date.getSeconds() 
                   
                    data.registration_hour = formatted_time
                    data.registration_date = formatted_date
                  }

                  if(data.member_since) {
                  
                    data.member_since= new Date(data.member_since.seconds*1000)
                   
                    let formatted_date = data.member_since.getFullYear() + "-" + ("0" + (data.member_since.getMonth() + 1)).slice(-2) + "-" +("0" + data.member_since.getDate()).slice(-2)
                    let formatted_time = data.member_since.getHours() + ":" + data.member_since.getMinutes() + ":" + data.member_since.getSeconds() 
                   
                    data.member_since_hour = formatted_time
                    data.member_since = formatted_date
                  }
                 
                  if(data.role) {
                    switch (data.role) {
                      case 'SS':  
                          data.role= "Serviteurs";
                        break;
                      case "MC":
                          data.role= "Masanga";
                        break;
                        case "MS":
                          data.role= "Masanga";
                        break;
                      case "YY": 
                          data.role= "Youth";
                        break;
                      case "CC":
                          data.role= "Choristes";
                        break;
                      case "MM":
                          data.role= "Members";
                        break;
                        case "FF":
                          data.role= "Faithful";
                        break;
                        case "F":
                          data.role= "Faithful";
                        break;
                       default:
                          data.role= data.role;
                    }
                    
                  }
                  if(data.gender) {
                    switch (data.gender) {
                      case 'femme':
                          data.gender= "F";
                        break;
                      case "male":
                          data.gender= "M";
                        break;
                        case "homme":
                          data.gender= "M";
                        break;
                       default:
                          data.gender= data.gender;
                    }
                    
                  }
              users.push(data);
            
         // }

            });
          })
       // context.commit('loginLoading', false);
        setTimeout(() => {
         // context.commit('loginLoading', false)
          context.commit('users', users);
          resolve()
        }, 1000)
      })
   
    },

   //**************************************
   fetchCRE_emp: function (context,id) {
    return new Promise((resolve, reject) => {
      const users_emp_crea = [];
      var code = 187
      var i=0
      var currentUser = ''
      if (firebase.auth().currentUser) {
        currentUser = firebase.auth().currentUser.uid;
      }

      db
        .collection('Users')
        .where("created_by_id", "==", id)
        .orderBy('registration_date', 'desc')
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach(doc => {
            code=i+code 
            const data = {
              uuid: doc.id,
              access_code:doc.data().access_code ,
              address: doc.data().address,
              card_id :doc.data().card_id ,
              church_name :doc.data().church_name.toUpperCase() ,
              city: doc.data().city,
              date_of_birth: doc.data().date_of_birth,
              entityKey :doc.data().entityKey ,
              friend : doc.data().friend,
              gender : doc.data().gender,
              has_resume : doc.data().has_resume,
              lower_access_code :doc.data().lower_access_code ,
              lower_last_name :doc.data().lower_last_name ,
              marital_status : doc.data().marital_status,
              qr_url : doc.data().qr_url,
              region :doc.data().region ,
              original_date : doc.data().registration_date,
              registration_date : doc.data().registration_date,
              member_since:doc.data().member_since,
              type : doc.data().type,
              image_url: doc.data().image_url,
              standard_photo:doc.data().standard_photo,
              first_name: utils.jsUcfirst(doc.data().first_name),
              last_name: utils.jsUcfirst(doc.data().last_name),
              census_id: doc.data().census_id,
              status: doc.data().status,
              phone: doc.data().phone_number,
              online: doc.data().online,
              email: doc.data().email,
              status: doc.data().status,
              thumbnail_url: doc.data().thumbnail_url,
              fullName: doc.data().first_name + ' ' + doc.data().last_name,
              name: doc.data().first_name + ' ' + doc.data().last_name,
              role:doc.data().role,
              payment_made :doc.data().payment_made+ "",
              bar_code:'OMNIC3 SARL 0000',
              avatar: {
                src: '/static/avatar/avatar.png',
                size: 72
              },
            };
            if(data.payment_made == "true") {data.amount="5"} else {data.amount="0"}
            
            if (data.image_url.length ==0 ) {
              data.image_url = '/static/avatar/avatar.png';
            }
  
             if (data.image_url === "default" ) {
              data.image_url = '/static/avatar/avatar.png';
            }
           
        if (data.standard_photo.length == 0 ) {
         
          data.standard_photo = '/static/avatar/avatar.png';
        }
            data.avatar = data.image_url

              ///////*************** */

              if(doc.data().qr_url != undefined) {
                var qr =  doc.data().qr_url
              data.qr_name=qr.substring(
                qr.lastIndexOf("%2F") + 3, 
                qr.lastIndexOf("?")
                 )+".png"
              }
  
              if(doc.data().standard_photo == '/assets/avatar.png') {
  
                data.image_name = "avatar.png"
              }
              else if(doc.data().standard_photo != undefined) {
                var image =  doc.data().standard_photo
                data.image_name=image.substring(
                image.lastIndexOf("%2F") + 3, 
                image.lastIndexOf("?")
                 )+".jpg"
              } 

              if(data.date_of_birth) {
             
                data.date_of_birth=  new Date(data.date_of_birth.seconds*1000)
                let formatted_date = data.date_of_birth.getFullYear() + "-" + ("0" + (data.date_of_birth.getMonth() + 1)).slice(-2) + "-" +("0" + data.date_of_birth.getDate()).slice(-2)
                data.date_of_birth = formatted_date
               }
                data.original_date = new Date(data.original_date.seconds*1000)
                if(data.registration_date) {
                
                  data.registration_date= new Date(data.registration_date.seconds*1000)
                 
                  let formatted_date = data.registration_date.getFullYear() + "-" + ("0" + (data.registration_date.getMonth() + 1)).slice(-2) + "-" +("0" + data.registration_date.getDate()).slice(-2)
                  let formatted_time = data.registration_date.getHours() + ":" + data.registration_date.getMinutes() + ":" + data.registration_date.getSeconds() 
                 
                  data.registration_hour = formatted_time
                  data.registration_date = formatted_date
                }

                if(data.member_since) {
                
                  data.member_since= new Date(data.member_since.seconds*1000)
                 
                  let formatted_date = data.member_since.getFullYear() + "-" + ("0" + (data.member_since.getMonth() + 1)).slice(-2) + "-" +("0" + data.member_since.getDate()).slice(-2)
                  let formatted_time = data.member_since.getHours() + ":" + data.member_since.getMinutes() + ":" + data.member_since.getSeconds() 
                 
                  data.member_since_hour = formatted_time
                  data.member_since = formatted_date
                }
               
                if(data.role) {
                  switch (data.role) {
                    case 'SS':  
                        data.role= "Serviteurs";
                      break;
                    case "MC":
                        data.role= "Masanga";
                      break;
                      case "MS":
                        data.role= "Masanga";
                      break;
                    case "YY": 
                        data.role= "Youth";
                      break;
                    case "CC":
                        data.role= "Choristes";
                      break;
                    case "MM":
                        data.role= "Members";
                      break;
                      case "FF":
                        data.role= "Faithful";
                      break;
                      case "F":
                        data.role= "Faithful";
                      break;
                     default:
                        data.role= data.role;
                  }
                  
                }
                if(data.gender) {
                  switch (data.gender) {
                    case 'femme':
                        data.gender= "F";
                      break;
                    case "male":
                        data.gender= "M";
                      break;
                      case "homme":
                        data.gender= "M";
                      break;
                     default:
                        data.gender= data.gender;
                  }
                  
                }
                users_emp_crea.push(data);
          
       // }

          });
        })
     // context.commit('loginLoading', false);
      setTimeout(() => {
       // context.commit('loginLoading', false)
        context.commit('users_emp_crea', users_emp_crea);
        resolve()
      }, 1000)
    })
 
  },
   
   

    deleteMember: function (context, payload) {
      db.collection('Census').doc(payload).delete()
        .then(() => {
          context.commit('deleteMember', payload)
        })
    },
    deleteUser: function (context, payload) {
      db.collection('Users').doc(payload).delete()
        .then(() => {
          context.commit('deleteUser', payload)
        })
    },
    deleteUser_ecc: function (context, payload) {
      db.collection('Users_ecc').doc(payload).delete()
        .then(() => {
          context.commit('deleteUser_ecc', payload)
        })
    },
    deleteEmployee: function (context, payload) {
      db.collection('Employees').doc(payload).delete()
        .then(() => {
          context.commit('deleteEmployee', payload)
        })
    },
    fetchReferrals: function (context) {
      const Members = [];
      db
        .collection('Referrals')
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach(doc => {
            const data = {
              id: doc.id,
              firstName: doc.data().firstName,
              lastName: doc.data().lastName,
              accessCode: doc.data().accessCode,
              imageUrl: doc.data().imageUrl,
              cellType: 'Non connue',
              email: doc.data().email,
              phone: doc.data().phone,
              createdBy: doc.data().createdBy,
              role: doc.data().role,
              createdDate: doc.data().createdDate,
              city: doc.data().city
            };
            if (data.imageUrl === null || data.imageUrl === undefined) {
              data.imageUrl = '/static/avatar/avatar.png';
            }
            Members.push(data);
          });
        });
      context.commit('referrals', Members);
    },
    fetchEmployees: function (context) {
      const Members = [];
      db
        .collection('Employees')
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach(doc => {
            const data = {
              id: doc.id,
              firstName: doc.data().firstName,
              lastName: doc.data().lastName,
              email: doc.data().email,
              phone: ""+doc.data().phone,
              role: doc.data().accessLevel,
              fullName: doc.data().firstName+' '+doc.data().lastName,
              entrees: 0,
              avatar: {
                src: doc.data().imageUrl,
                size: 36
              }
            };
            if (data.role === 'Admin') {
              data.cardBgImage = '/static/bg/15.jpg';
            }
            if (data.lastName) {
              data.fullName = data.firstName + ' ' + data.lastName;
              // data.entrees = filterEmployees(data.fullName);
            }
            Members.push(data);
          });
        });
      context.commit('employees', Members);
    },


    fetchPrayers_ecc({
      commit
    }) {
      var prayers_ecc = [];
      db.collection('prayers_ecc')
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach(doc => {
            var prayer_ecc = {
              timestamp: doc.data().timestamp,
              text: doc.data().text
            }
            // prayer.timestamp =  prayer.timestamp | formatDate 

            prayers_ecc.push(prayer_ecc);
          })
          commit('prayers_ecc', prayers_ecc)
        })
        .catch((error) => {
          console.log(error)
        })
    },

    fetchPrayers({
      commit
    }) {
      var prayers = [];
      db.collection('prayers')
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach(doc => {
            var prayer = {
              timestamp: doc.data().timestamp,
              text: doc.data().text
            }
            // prayer.timestamp =  prayer.timestamp | formatDate 

            prayers.push(prayer);
          })
          commit('prayers', prayers)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    /************Annoncamenet ECC**************** */
    fetchAnnouncements_ecc({
      commit
    }) {
      var announcements_ecc = [];
      db.collection('announcements_ecc')
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach(doc => {
            var announcement_ecc = {
              timestamp: doc.data().timestamp,
              text: doc.data().text
            }
            // prayer.timestamp =  prayer.timestamp | formatDate 

            announcements_ecc.push(announcement_ecc);
          })
          commit('announcements_ecc', announcements_ecc)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    /****************************************** */
    fetchAnnouncements({
      commit
    }) {
      var announcements = [];
      db.collection('announcements')
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach(doc => {
            var announcement = {
              timestamp: doc.data().timestamp,
              text: doc.data().text
            }
            // prayer.timestamp =  prayer.timestamp | formatDate 

            announcements.push(announcement);
          })
          commit('announcements', announcements)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    fetchMessages: function (context) {
      return new Promise((resolve, reject) => {
        var currentUser = ''
        var type='';
        if (firebase.auth().currentUser) {
          currentUser = firebase.auth().currentUser.uid;
        }
        const messages = [];
        db.collection('Messages')
        .orderBy('timestamp')
         //.where('conversation_id', '==', 'sBnRhhSTKWeVvWHsoiJn')
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach(doc => {
                

              var message = {
                uuid: doc.data().entityKey,
                id:doc.data().id,
                from_id: doc.data().from_id,
                conversation_id: doc.data().conversation_id,
                from_thumbnail_url: doc.data().from_thumbnail_url,
                from_username: doc.data().from_username,
                participants: doc.data().participant_ids,
                sender:doc.data().sender,
                created_at: doc.data().timestamp,
                viewType:doc.data().viewType
              }
             
              if(doc.data().viewType==5 || doc.data().viewType==6) {
                message.data_type='image'
                message.image=doc.data().urls[0]
              }   
              else if(doc.data().viewType==1 || doc.data().viewType==2) { 
                message.data_type='primaryText'
                message.text=doc.data().text
              } 
             
             else if(doc.data().viewType==3 || doc.data().viewType==4) {
                message.data_type='audio'
                message.audio=doc.data().url
              }
             
              messages.push(message);

            })
            setTimeout(() => {
            //  console.log("in store"+JSON.stringify(messages))
              context.commit('messages', messages)
              resolve()
            }, 1000)
          })
          .catch((error) => {
            console.log(error)
          })
      })
    },


    fetchProjects: function (context) {
      return new Promise((resolve, reject) => {
        var currentUser = ''
        if (firebase.auth().currentUser) {
          currentUser = firebase.auth().currentUser.uid;
        }
        const projects = [];
        db.collection('projects')
        // .where('created_by_id', '==', currentUser)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach(doc => {
              const data = {
                id: doc.id,
                address:doc.data().address,
                city:doc.data().city,
                created_by_id:doc.data().created_by_id,
                created_date:doc.data().created_date,
                donation_accumulated:doc.data().donation_accumulated,
                donation_objective:doc.data().donation_objective,
                ending_date:doc.data().ending_date,
                hours_accumulated:doc.data().hours_accumulated,
                hours_objective:doc.data().hours_objective,
                postalCode:doc.data().postalCode,
                update_date:doc.data().update_date,
                updated_by:doc.data().updated_by,
                updated_by_id:doc.data().updated_by_id,
                title: doc.data().title,
                description: doc.data().description,
                status: doc.data().status,
                createdBy: doc.data().createdBy,
                type: doc.data().type,
                images: doc.data().images
              };
              projects.push(data); 
            })
            setTimeout(() => {
            //console.log("in store"+JSON.stringify(messages))
              context.commit('projects', projects)
              resolve()
            }, 1000)
          })
          .catch((error) => {
            console.log(error)
          })
      })
    },

    fetchConvos: function (context) {
     return new Promise((resolve, reject) => {
      
        const convos = [];
        const groups = []
        var currentUser = ''
         if (firebase.auth().currentUser) {
          currentUser = firebase.auth().currentUser.uid;
        } 
 
     
        db.collection('conversations')
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach(doc => {

              if(doc.data().type=='single') {
              const convo = {
                uuid: doc.id,
                last_message: doc.data().last_message,
                created_date: doc.data().last_update,
                participants: doc.data().participants,
                users: [],
                type:doc.data().type
              }
             if (convo.participants.find(item => item.user_id ===currentUser)) {
                convo.participants.forEach((item) => {
                  if (item.user_id !==currentUser) {
                   // convo.title = "test title";
                     convo.title = item.first_name + ' ' + item.last_name;
                 //   console.log("user id")
                   
                    if (item.thumbnail_url === 'default') {
                      convo.avatar = '/static/avatar/avatar.png';
                    } else {
                      convo.avatar = item.thumbnail_url;
                    }
                    convo.created_by = currentUser
                    convo.users.push(item.user_id)
                  }
                 // convo.title = "test title";
                })
              
                convos.push(convo);
              }  

            } else {

              const group = {
                uuid: doc.id,
                last_message: doc.data().last_message,
                created_date: doc.data().last_update,
                participants: doc.data().participants,
                users: [],
                type:doc.data().type
              }
             if (group.participants.find(item => item.user_id ===currentUser)) {
              group.participants.forEach((item) => {
                  if (item.user_id !==currentUser) {
                   // convo.title = "test title";
                   group.title = doc.data().title;
                 //   console.log("user id")
                   
                    if (item.thumbnail_url === 'default') {
                      group.avatar = '/static/avatar/avatar.png';
                    } else {
                      group.avatar = item.thumbnail_url;
                    }
                    group.created_by = currentUser
                    group.users.push(item.user_id)
                  }
                 // convo.title = "test title";
                })
              
                groups.push(group);
              }  



            }
            })
            context.commit('loginLoading', false);
            setTimeout(() => {
              context.commit('convos', convos);
              context.commit('groups', groups);
              resolve()
            }, 1000)
          })
          .catch((error) => {
            console.log(error)
          })
     })
    },
  }
});
// actions end

async function fetch_Member(member_id) {
  let memberRef = db.collection('Census').doc(member_id)
  let activeRef = await memberRef.get()
    .then((doc) => {
      const form = {
        id: doc.id,
        imageUrl: doc.data().imageUrl,
        firstName: doc.data().firstName,
        lastName: doc.data().lastName,
        accessCode: doc.data().accessCode,
        role: doc.data().role,
        phone: doc.data().phone,
        email: doc.data().email,
        dateOfBirth: doc.data().dateOfBirth,
        address: doc.data().address,
        gender: doc.data().gender,
        consent: doc.data().consent,
        city: doc.data().city,
        postalCode: doc.data().postalCode,
        isWithChildren: doc.data().isWithChildren,
        hasSmartPhone: doc.data().hasSmartPhone,
        noPhoneReason: doc.data().noPhoneReason,
        isBuyPhoneReady: doc.data().isBuyPhoneReady,
        maritalStatus: doc.data().maritalStatus,
        noVolunteerReason: doc.data().noVolunteerReason,
        isVolunteer: doc.data().isVolunteer,
        hasChildren: doc.data().hasChildren,
        volunteerFrequency: doc.data().volunteerFrequency,
        niveauScolaire: doc.data().niveauScolaire,
        churchName: doc.data().churchName,
        churchAttendance: doc.data().churchAttendance,
        memberSince: doc.data().memberSince,
        sermonTimeSpent: doc.data().sermonTimeSpent,
        isreferralReady: doc.data().isreferralReady,
        noReferralReason: doc.data().noReferralReason,
        isVolunteerReady: doc.data().isVolunteerReady,
        noVolunteerReason: doc.data().noVolunteerReason,
        volunteerTime: doc.data().volunteerTime,
        noDonationReason: doc.data().noDonationReason,
        donation: doc.data().donation,
        isDimeContribution: doc.data().isDimeContribution,
        isDonationReady: doc.data().isDonationReady,
        // dimeAmount: doc.data().dimeAmount,
        dime: doc.data().dime,
        dimeType: doc.data().dimeType,
        isOffrandeContribution: doc.data().isOffrandeContribution,
        // offrandeAmount: doc.data().offrandeAmount,
        offrandeType: doc.data().offrandeType,
        offrande: doc.data().offrande,
        isGraceContribution: doc.data().isGraceContribution,
        // graceDonationAmount: doc.data().graceDonationAmount,
        graceContributionType: doc.data().graceContributionType,
        isWorking: doc.data().isWorking,
        createdDate: doc.data().createdDate,
        isWorkReady: doc.data().isWorkReady,
        notAvailableReason: doc.data().notAvailableReason,
        isEducationReady: doc.data().isEducationReady,
        isHouseOwner: doc.data().isHouseOwner,
        houseOwnerSince: doc.data().houseOwnerSince,
        isRenting: doc.data().isRenting,
        jobSkills: doc.data().jobSkills,
        jobSearch: doc.data().jobSearch,
        jobType: doc.data().jobType,
        availableTime: doc.data().availableTime,
        jobDisponibility: doc.data().jobDisponibility,
        timeOnCurrentJob: doc.data().timeOnCurrentJob,
        jobPosition: doc.data().jobPosition,
        numberOfJobs: doc.data().numberOfJobs,
        jobRepartition: doc.data().jobRepartition,
        jobWeeklyHours: doc.data().jobWeeklyHours,
        jobTravelDistance: doc.data().jobTravelDistance,
        jobTravelMode: doc.data().jobTravelMode,
        jobTravelCost: doc.data().jobTravelCost,
        jobTravelTime: doc.data().jobTravelTime,
        jobMonthlyPay: doc.data().jobMonthlyPay
      }

      if (doc.data().imageUrl === "./src/assets/avatar.png") {
        form.imageUrl = memberPhoto;
      }
      if (
        doc.data().isBuyPhoneReady === null ||
        doc.data().isBuyPhoneReady === undefined
      ) {
        form.isBuyPhoneReady = false;
      }
      if (
        doc.data().isVolunteerReady === null ||
        doc.data().isVolunteerReady === undefined
      ) {
        form.isVolunteerReady = "Non";
      }
      if (
        doc.data().volunteerTime === null ||
        doc.data().volunteerTime === undefined
      ) {
        form.volunteerTime = {
          amount: 0,
          frequency: 'Par jour'
        }
      }
      if (
        doc.data().donation === null ||
        doc.data().donation === undefined
      ) {
        form.donation = {
          amount: 0,
          frequency: 'Par jour'
        }
      }
      if (
        doc.data().houseOwnerSince === null ||
        doc.data().houseOwnerSince === undefined
      ) {
        form.houseOwnerSince = {
          nombre: 0,
          frequency: 'Par jour'
        }
      }
      if (
        doc.data().education === null ||
        doc.data().education === undefined
      ) {
        form.education = {
          nombre: 0,
          frequency: 'Par jour'
        }
      }
      if (
        doc.data().numberOfKids === null ||
        doc.data().noPhoneReason === undefined
      ) {
        form.numberOfKids = 0;
      }
      if (
        doc.data().noReferralReason === null ||
        doc.data().noReferralReason === undefined
      ) {
        form.noReferralReason = 'Pas de raison';
      }
    })
  return form
}

function filterProviders(data) {

  if (data.phone) {
    let phonePrefix = data.phone.substring(0, 2);

    if (phonePrefix === '90') {
      data.cellType = 'africell';
    }
    if (phonePrefix === '80' || phonePrefix === '84' || phonePrefix === '85' || phonePrefix === '89') {
      data.cellType = 'orangeTigo';
    }

    if (phonePrefix === '81' || phonePrefix === '82') {
      data.cellType = 'vodaphone';
    }

    if (phonePrefix === '97' || phonePrefix === '98' || phonePrefix === '99') {
      data.cellType = 'airtel';
    }

  }

}

function filterProviders2(data) {

  if (data.phone) {
    let phonePrefix3 = data.phone.substring(0, 3);
    if (phonePrefix3 === '090') {
      data.cellType = 'africell';
    }
    if (phonePrefix3 === '080' || phonePrefix3 === '084' || phonePrefix3 === '085' || phonePrefix3 === '089') {
      data.cellType = 'orangeTigo';
    }
    if (phonePrefix3 === '081' || phonePrefix3 === '082') {
      data.cellType = 'vodaphone';
    }
    if (phonePrefix3 === '097' || phonePrefix3 === '098' || phonePrefix3 === '099') {
      data.cellType = 'airtel';
    }
  }
}
// function filterEmployees (employee) {
//   const entrees = state.Members.filter(item => (item.createdBy) === employee.fullName);
//   console.log(entrees.length);
//   return entrees.length;
// }


// WEBPACK FOOTER //
// ./src/api/store.js